'use strict';

module.exports = {
  filterForOnlineStore: function() {
    // $('.js-store-filter-online').on('click', function(e) {
    //   e.preventDefault();
    //   e.stopImmediatePropagation();
    // })
  },
  filterForStore: function() {
    $('.filter-store').on('click', function(e) {
      e.preventDefault();
      e.stopImmediatePropagation();

      var brandsContainer = $('.brands-content');
      var brandsAlphabet = $('.brands-alphabet');

      window.$.spinner().start();

      brandsContainer.attr('style', 'visibility:hidden');
      brandsAlphabet.attr('style', 'visibility:hidden');


      var $li = $(this).parent();
      $li.toggleClass('selected');

      var $storesSelected = $('.js-store.selected');
      var storesIDs = []
      $storesSelected.each(function(i, store) {
        if ($(store).hasClass('shop-online-filter')) {
          storesIDs.push('online');
        } else {
          storesIDs.push($(store).data('storeid'));
        }
      })


      // nascondo tutti i brand e li mostro solo se esiste corrispondenza store->brand
      // la condizione se ci sono più store selezionati è in OR
      var brands = brandsContainer.find('.listing-brand-button');
      if (storesIDs.length) {
        brands.each(function(i, brand) {
          $(brand).addClass('d-none');
          var stores = $(brand).data('stores');
          storesIDs.forEach(storeId => {
            if ((storeId == 'online' && $(brand).find('.online-flag').length) || (stores && stores.toString().indexOf(storeId) != -1)) {
              $(brand).removeClass('d-none');
            }
          });
        });
      } else {
        brands.each(function(i, brand) {
          $(brand).removeClass('d-none');
        });
      }

      // se ci sono lettere dell'alfabeto vuote si nascondono e si nascondono anche le lettere nella sidebar brandsAlphabet
      var brandsGroups = $('.js-brand-group');
      brandsGroups.removeClass('d-none')
      brandsGroups.each(function(i, brandsGroup) {
        var sideBarGroup = $(`.brands-alphabet li[data-id=${$(brandsGroup).attr('id')}]`)
        var groupHasBrand = $(brandsGroup).find('.listing-brand-button:visible').length
        if (groupHasBrand) {
          $(brandsGroup).removeClass('d-none');
          sideBarGroup.removeClass('d-none');
        } else {
          $(brandsGroup).addClass('d-none');
          sideBarGroup.addClass('d-none');
        }
      })

      var storeFilteredList = $('.js-stores-filtered-list');
      if (storeFilteredList.length > 0) {
        storeFilteredList.empty();
        for (var i = 0; i < $storesSelected.length; i++) {
          var address = $($storesSelected[i]).find('.address').text();
          var city = $($storesSelected[i]).find('.city').text();
          if (address.length == 0 && city.length == 0) {
            storeFilteredList.append('<li>' +  ' Acquista Online ' + '</li>');
          } else {
            storeFilteredList.append('<li>' + address + ' - ' + city + '</li>');
          }
        }
      }


      brandsContainer.removeAttr('style');
      brandsAlphabet.removeAttr('style');

      window.$.spinner().stop();
    })
  }
}